const getters = {
  token: state => state.user.token,
  info: state => state.user.info,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  dict: state => state.dict.dict,
}
export default getters
